import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-preset-category", "aria-label"]
const _hoisted_2 = { role: "status" }
const _hoisted_3 = {
  key: 0,
  role: "alert"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 4 }
const _hoisted_8 = { key: 5 }
const _hoisted_9 = { key: 6 }
const _hoisted_10 = { class: "items system-items" }
const _hoisted_11 = ["data-preset-id", "aria-label"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["onUpdate:modelValue", "disabled", "aria-label", "placeholder"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 2,
  class: "show-title-toggle"
}
const _hoisted_16 = ["onUpdate:modelValue", "disabled", "aria-label"]
const _hoisted_17 = { key: 3 }
const _hoisted_18 = { key: 7 }
const _hoisted_19 = ["data-preset-id", "aria-label"]
const _hoisted_20 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_21 = ["onUpdate:modelValue", "aria-label", "placeholder"]
const _hoisted_22 = {
  key: 0,
  class: "show-title-toggle"
}
const _hoisted_23 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_24 = ["aria-label", "onClick"]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "preset-footer" }
const _hoisted_29 = ["disabled"]

import { computed, nextTick, ref } from "vue";
import StyleParameterSettings from "./StyleParameterSettings.vue";
import TypedValueInput from "../TypedValueInput.vue";
import type { PresetReference } from "./presetReferences";
import { createStylePreset, getStylePresetValueType, supportsCustomStylePresets, supportsEditableSystemStylePresets, supportsStyleParameters, useStylePresets, type StylePresetCategory } from "./stylePresets";

export default /*@__PURE__*/_defineComponent({
  __name: 'StylePresetSection',
  props: {
    category: {},
    title: {},
    referenceSources: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;
const supportsCustom = computed(() => supportsCustomStylePresets(props.category));
const editableSystem = computed(() => supportsEditableSystemStylePresets(props.category));
const editableSystemValue = computed(() => editableSystem.value && props.category !== "selectStyles");
const supportsParameters = computed(() => supportsStyleParameters(props.category));
const valueType = computed(() => getStylePresetValueType(props.category));
const valueLabel = computed(() => props.category === "cameras" ? "相机名称" : "类型值");
const { customPresets, systemPresets, availablePresets, ready, error, status, retry, flush } = useStylePresets(props.category);
const systemIDs = computed(() => new Set(systemPresets.value.map(preset => preset.id)));
const entries = computed(() => availablePresets.value.map(preset => ({
  id: preset.id,
  label: preset.label || preset.value || "未命名预设",
  detail: preset.value,
  system: systemIDs.value.has(preset.id),
})));
const list = ref<HTMLElement>();
async function add() {
  if (!supportsCustom.value) return;
  customPresets.value = [...customPresets.value, createStylePreset(props.category)];
  await nextTick();
  list.value?.querySelector<HTMLElement>("article:last-child input")?.focus();
}
__expose({ flush, category: props.category, entries });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: "style-preset-section",
    "data-preset-category": __props.category,
    "aria-label": `${__props.title}预设`
  }, [
    _createElementVNode("header", null, [
      _createElementVNode("div", null, [
        _createElementVNode("h3", null, _toDisplayString(__props.title), 1),
        _createElementVNode("p", null, "显示名称用于选择，" + _toDisplayString(valueLabel.value) + "按原文保存和导出。", 1)
      ])
    ]),
    _createElementVNode("p", _hoisted_2, _toDisplayString(supportsCustom.value ? _unref(status) : '系统预设 · 只读'), 1),
    (_unref(error))
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
          _createTextVNode(_toDisplayString(_unref(error)) + " ", 1),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(retry)().catch(() => undefined)))
          }, "重试")
        ]))
      : _createCommentVNode("", true),
    (editableSystemValue.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, "系统预设提供默认值，显示名称固定，实际值可修改。自定义预设可新增、编辑和删除，当前工作区共用。"))
      : (supportsParameters.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, "系统预设的显示名称和类型值固定，可编辑参数。自定义预设可新增、编辑和删除，当前工作区共用。"))
        : (supportsCustom.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, "系统预设只读。自定义预设可新增、编辑和删除，当前工作区共用。"))
          : _createCommentVNode("", true),
    (supportsCustom.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, "修改预设不会改写已配置的内容。"))
      : _createCommentVNode("", true),
    (__props.category === 'dialogueStyles')
      ? (_openBlock(), _createElementBlock("p", _hoisted_8, "显示标题控制文本编辑中的标题（说话人）和副标题；关闭时导出为空，已填写的文字保留在工程中。"))
      : _createCommentVNode("", true),
    (supportsParameters.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_9, "参数名称、值来源和默认值在参数设置中定义，类型固定为整数。文本或选项使用该预设后，按定义的参数填写入参。"))
      : _createCommentVNode("", true),
    _createElementVNode("h4", null, _toDisplayString(editableSystem.value ? '系统预设 · 默认值' : '系统预设 · 只读'), 1),
    _createElementVNode("div", _hoisted_10, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(systemPresets), (preset, index) => {
        return (_openBlock(), _createElementBlock("article", {
          key: preset.id,
          "data-preset-id": preset.id,
          tabindex: "-1",
          class: _normalizeClass({ 'dialogue-style': __props.category === 'dialogueStyles' }),
          "aria-label": `系统${__props.title}预设 ${index + 1}`
        }, [
          _createElementVNode("div", null, [
            _cache[1] || (_cache[1] = _createTextVNode("显示名称", -1)),
            _createElementVNode("p", null, _toDisplayString(preset.label || preset.value), 1)
          ]),
          (editableSystemValue.value)
            ? (_openBlock(), _createElementBlock("label", _hoisted_12, [
                _createTextVNode(_toDisplayString(valueLabel.value), 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": ($event: any) => ((preset.value) = $event),
                  disabled: !_unref(ready),
                  "aria-label": `系统${__props.title} ${index + 1} ${valueLabel.value}`,
                  placeholder: `填写实际使用的${valueLabel.value}`
                }, null, 8, _hoisted_13), [
                  [_vModelText, preset.value]
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createTextVNode(_toDisplayString(valueLabel.value), 1),
                _createElementVNode("p", null, _toDisplayString(preset.value), 1)
              ])),
          (__props.category === 'dialogueStyles')
            ? (_openBlock(), _createElementBlock("label", _hoisted_15, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": ($event: any) => ((preset.showTitle) = $event),
                  disabled: !_unref(ready),
                  type: "checkbox",
                  "aria-label": `系统${__props.title} ${index + 1} 显示标题`
                }, null, 8, _hoisted_16), [
                  [_vModelCheckbox, preset.showTitle]
                ]),
                _cache[2] || (_cache[2] = _createTextVNode("显示标题", -1))
              ]))
            : _createCommentVNode("", true),
          _cache[3] || (_cache[3] = _createElementVNode("span", null, "系统", -1)),
          (editableSystemValue.value && !preset.value.trim())
            ? (_openBlock(), _createElementBlock("small", _hoisted_17, "填写" + _toDisplayString(valueLabel.value) + "后即可在编辑器中选择。", 1))
            : _createCommentVNode("", true),
          (supportsParameters.value)
            ? (_openBlock(), _createBlock(StyleParameterSettings, {
                key: 4,
                modelValue: preset.parameters,
                "onUpdate:modelValue": ($event: any) => ((preset.parameters) = $event),
                class: "parameter-settings",
                "reference-sources": __props.referenceSources,
                disabled: !_unref(ready),
                label: `系统${__props.title} ${index + 1}`
              }, null, 8, ["modelValue", "onUpdate:modelValue", "reference-sources", "disabled", "label"]))
            : _createCommentVNode("", true)
        ], 10, _hoisted_11))
      }), 128))
    ]),
    (!_unref(systemPresets).length)
      ? (_openBlock(), _createElementBlock("p", _hoisted_18, "暂无系统预设。"))
      : _createCommentVNode("", true),
    (supportsCustom.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
          _cache[6] || (_cache[6] = _createElementVNode("header", null, [
            _createElementVNode("h4", null, "自定义预设")
          ], -1)),
          _createElementVNode("div", {
            ref_key: "list",
            ref: list,
            class: "items"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(customPresets), (preset, index) => {
              return (_openBlock(), _createElementBlock("article", {
                key: preset.id,
                "data-preset-id": preset.id,
                tabindex: "-1",
                class: _normalizeClass({ 'dialogue-style': __props.category === 'dialogueStyles' }),
                "aria-label": `${__props.title}预设 ${index + 1}`
              }, [
                _createElementVNode("label", null, [
                  _cache[4] || (_cache[4] = _createTextVNode("显示名称", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": ($event: any) => ((preset.label) = $event),
                    "aria-label": `${__props.title} ${index + 1} 显示名称`,
                    placeholder: "例如：默认样式"
                  }, null, 8, _hoisted_20), [
                    [_vModelText, preset.label]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _createTextVNode(_toDisplayString(valueLabel.value), 1),
                  (valueType.value === 'Int32')
                    ? (_openBlock(), _createBlock(TypedValueInput, {
                        key: 0,
                        modelValue: preset.value,
                        "onUpdate:modelValue": ($event: any) => ((preset.value) = $event),
                        "value-type": valueType.value,
                        "aria-label": `${__props.title} ${index + 1} ${valueLabel.value}`,
                        placeholder: "填写整数值"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "value-type", "aria-label"]))
                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 1,
                        "onUpdate:modelValue": ($event: any) => ((preset.value) = $event),
                        "aria-label": `${__props.title} ${index + 1} ${valueLabel.value}`,
                        placeholder: `填写实际使用的${valueLabel.value}`
                      }, null, 8, _hoisted_21)), [
                        [_vModelText, preset.value]
                      ])
                ]),
                (__props.category === 'dialogueStyles')
                  ? (_openBlock(), _createElementBlock("label", _hoisted_22, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": ($event: any) => ((preset.showTitle) = $event),
                        type: "checkbox",
                        "aria-label": `${__props.title} ${index + 1} 显示标题`
                      }, null, 8, _hoisted_23), [
                        [_vModelCheckbox, preset.showTitle]
                      ]),
                      _cache[5] || (_cache[5] = _createTextVNode("显示标题", -1))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  "aria-label": `删除${__props.title}预设 ${index + 1}`,
                  onClick: ($event: any) => (customPresets.value = _unref(customPresets).filter(item => item.id !== preset.id))
                }, "删除", 8, _hoisted_24),
                (!preset.value.trim())
                  ? (_openBlock(), _createElementBlock("small", _hoisted_25, "填写" + _toDisplayString(valueLabel.value) + "后即可在编辑器中选择。", 1))
                  : (_unref(availablePresets).some(item => item !== preset && item.value === preset.value))
                    ? (_openBlock(), _createElementBlock("small", _hoisted_26, _toDisplayString(valueLabel.value) + "重复，选择列表优先显示系统预设，再显示第一项自定义预设。", 1))
                    : _createCommentVNode("", true),
                (supportsParameters.value)
                  ? (_openBlock(), _createBlock(StyleParameterSettings, {
                      key: 3,
                      modelValue: preset.parameters,
                      "onUpdate:modelValue": ($event: any) => ((preset.parameters) = $event),
                      class: "parameter-settings",
                      "reference-sources": __props.referenceSources,
                      disabled: !_unref(ready),
                      label: `${__props.title} ${index + 1}`
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "reference-sources", "disabled", "label"]))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_19))
            }), 128))
          ], 512),
          (_unref(ready) && !_unref(customPresets).length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_27, "暂无自定义预设，可以点击新建添加。"))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("button", {
              type: "button",
              disabled: !_unref(ready),
              onClick: add
            }, "＋ 新建" + _toDisplayString(__props.title) + "预设", 9, _hoisted_29)
          ])
        ], 64))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})